'use strict';

import {theme} from 'core_theme_2';

import footerTemp from './directives/templates/footer.html';
import menuTemp from './directives/templates/menu.html';

const overrides = {
  'siteMenu': menuTemp,
  'tagline': theme.directiveOverrides.tagline,
  'slider': theme.directiveOverrides.slider,
  'footerTagline': theme.directiveOverrides.footerTagline,
  'videoBlock': theme.directiveOverrides.videoBlock,
  'modelBlock': theme.directiveOverrides.modelBlock,
  'comingSoonVideos': theme.directiveOverrides.comingSoonVideos,
  'siteFooter': footerTemp
};

export default function directiveOverrides($provide) {
  for( let direct in overrides ) {
    let template = overrides[direct];

    $provide.decorator(direct + 'Directive', ($delegate) => {
      let directive = $delegate[0];

      directive.template = template;

      return $delegate;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.directive.config.js